import { type ReactElement, useEffect } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledLabel } from "./Form.styles";
import type { FormLabelProps } from "./Form.types";
import { useFormFieldContext } from "./FormFieldContext";

const FormLabelComponent = ({
  children,
  className,
  required,
  id,
  htmlFor,
  ...rest
}: FormLabelProps): ReactElement => {
  const field = useFormFieldContext();
  const register = field?.registerLabel;

  useEffect(() => register?.(id), [register, id]);

  return (
    <StyledLabel
      className={cx(className, Boolean(required) && "is-required")}
      id={id ?? (field && !field.hasExternalLabel ? field.labelId : undefined)}
      htmlFor={htmlFor ?? field?.controlId}
      {...rest}
    >
      {children}
    </StyledLabel>
  );
};

export const FormLabel = styled(FormLabelComponent)``;
